import PropTypes from 'prop-types';
import React from 'react';
import { MaterialCheckbox } from "reactifi";
import i18n from 'lib/utility/i18n';

export default class InviteFormCustomization extends React.Component {
  static propTypes = {
    invite_config: PropTypes.object
  }

  constructor(props){
    super(props);
    this.state = {
      invite_config: this.props.invite_config
    }
  }

  checkbox = (dataName, label) => {
    const dataField = `invite_${dataName}`;
    const inputName = `invite_config[${dataName}]`;
    return (
      <MaterialCheckbox
        data-field-name={dataField}
        dataValue={this.state.invite_config[dataName]}
        label={i18n.t(label)}
        name={inputName}
        valueOverride={true}
      />
    )
  }

  render(){
    return (
      <div className="custom-invite-form">
        <h5>{i18n.t('Send Invite Configurable Fields')}</h5>
        <div>{i18n.t('Select which optional fields will be available on the Send Invite page for all programs of this account.')}</div>
        <div className="custom-form-elements d-flex flex-column">
          { this.checkbox('recipient_name', 'Recipient Name') }
          { this.checkbox('message', 'Message') }
          { this.checkbox('postal_code', 'Postal Code') }
        </div>
      </div>
    )
  }
}
